import { VerificationLevel } from '@web/walter-lib/api'

export const getKycLevelName = (kycLevel?: number) => {
    if (!kycLevel) {
        return undefined
    }

    return VerificationLevel[kycLevel].toLowerCase()
}
